import { SVGProps } from 'react';

export default function ChevronDown(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 12, stroke = '#545454', ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M9.95906 4.47656L6.69906 7.73656C6.31406 8.12156 5.68406 8.12156 5.29906 7.73656L2.03906 4.47656'
        stroke={stroke}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
